/**
 * BE BOLD : Path A: Strengthen and Build
 * Month 4: Transition (Days 91-120)
 *
 * Standing squeezes. The Knack. Hold 10s mastery.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  bridge_activation: {
    id: 'bridge_activation',
    name: 'Bridge Activation',
    name_pt: 'Ponte com Ativação',
    sub: 'Squeeze first, then lift hips. Always this order.',
    sub_pt: 'Aperte primeiro, depois levante quadril. Sempre essa ordem.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie on your back, knees bent, feet flat.

Squeeze pelvic floor first. THEN lift hips into a bridge. Hold bridge AND squeeze for 5 seconds.

Lower hips slowly. Release squeeze as hips touch ground.

The sequence: floor first, then hips. Always.

Picture it: a drawbridge raising. Chains pull first (pelvic floor), THEN bridge lifts (hips). Chains always lead.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Aperte assoalho primeiro. DEPOIS levante quadril em ponte. Segure ponte E aperto por 5 segundos.

Abaixe quadril devagar. Solte aperto quando quadril tocar chão.

A sequência: assoalho primeiro, depois quadril. Sempre.

Visualize: ponte levadiça subindo. Correntes puxam primeiro (assoalho), DEPOIS ponte sobe (quadril). Correntes sempre lideram.`,
    breathe: 'Exhale to squeeze and lift. Inhale to lower and release.',
    breathe_pt: 'Expire para apertar e levantar. Inspire para abaixar e soltar.',
    timerCue: `Squeeze.
Lift.
Hold.
Lower.`,
    timerCue_pt: `Aperte.
Levante.
Segure.
Abaixe.`,
    feel: 'Floor and glutes working together. The floor starts first.',
    feel_pt: 'Assoalho e glúteos trabalhando juntos. O assoalho começa primeiro.',
    avoid: 'Do not lift before squeezing. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não levante antes de apertar. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 10,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  fast_squeeze: {
    id: 'fast_squeeze',
    name: 'Fast Squeeze',
    name_pt: 'Aperto Rápido',
    sub: 'Maximum effort. 1 second. Full release.',
    sub_pt: 'Esforço máximo. 1 segundo. Soltura total.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. Squeeze at maximum effort for 1 second. Release completely for 2 seconds.

This targets fast-twitch fibers that handle pressure spikes: coughing, laughing, sneezing, jumping.

Picture it: flicking a light switch. On for 1 second. Off completely. No dimming.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Aperte com esforço máximo por 1 segundo. Solte completamente por 2 segundos.

Isso trabalha fibras rápidas que lidam com picos de pressão: tosse, risada, espirro, salto.

Visualize: interruptor de luz. Liga 1 segundo. Desliga completamente. Sem dimmer.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze!
Release.`,
    timerCue_pt: `Aperte!
Solte.`,
    feel: 'Sharp, fast contraction. Full instant release.',
    feel_pt: 'Contração aguda e rápida. Soltura instantânea total.',
    avoid: 'Do not let tension linger. Do not bear down.',
    avoid_pt: 'Não deixe tensão persistir. Não faça força.',
    type: 'pulse',
    sets: 4,
    rest: 10,
    reps: 12,
    on: 1,
    off: 2,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  pulsacao: {
    id: 'pulsacao',
    name: 'Pulsação',
    name_pt: 'Pulsação',
    sub: '1 second on, 1 second off. Clean rhythm. Each rep starts fresh.',
    sub_pt: '1 segundo liga, 1 segundo desliga. Ritmo limpo. Cada repetição começa limpa.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit with feet flat. CLOSE and SQUEEZE for 1 second. Release completely for 1 second. That is one rep.

Each contraction is independent. Do not let tension accumulate across reps. The release is 50% of the exercise.

After each set, do 3 Gentle Pushes to confirm full rest.

Picture it: a camera shutter. Click open, click closed. Sharp and complete. No blur between open and closed.`,
    inst_pt: `Sente com pés apoiados. FECHE e APERTE por 1 segundo. Solte completamente por 1 segundo. Isso é uma repetição.

Cada contração é independente. Não deixe tensão acumular. A soltura é 50% do exercício.

Após cada série, faça 3 Empurrões Suaves para confirmar repouso.

Visualize: obturador de câmera. Clique abre, clique fecha. Nítido e completo. Sem borrão.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Release.`,
    timerCue_pt: `Aperte.
Solte.`,
    feel: 'Clean on-off rhythm. Release as complete as contraction.',
    feel_pt: 'Ritmo liga-desliga limpo. Soltura tão completa quanto contração.',
    avoid: 'Do not let tension build across reps. Do not bear down.',
    avoid_pt: 'Não deixe tensão acumular entre repetições. Não faça força.',
    type: 'pulse',
    sets: 5,
    rest: 10,
    reps: 12,
    on: 1,
    off: 1,
  },

  squeeze_10s: {
    id: 'squeeze_10s',
    name: 'Peak Hold 10s',
    name_pt: 'Sustentação Pico 10s',
    sub: '70% effort. 10 seconds.',
    sub_pt: '70% de esforço. 10 segundos.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit on chair. CLOSE and SQUEEZE 70%. Hold 10 seconds. Release 10 seconds.

If you cannot hold 10 seconds, hold as long as you can and note the time. Build from there.

Picture it: climbing stairs. Step 1 at 3 seconds. Step 2 at 5. Step 3 at 8. Step 4 at 10. Rest on each landing.`,
    inst_pt: `Sente na cadeira. FECHE e APERTE 70%. Segure 10 segundos. Solte 10 segundos.

Se não conseguir segurar 10 segundos, segure o quanto puder e anote. Construa a partir daí.

Visualize: subindo escadas. Degrau 1 em 3 segundos. Degrau 2 em 5. Degrau 3 em 8. Degrau 4 em 10. Descanse em cada patamar.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 10.
Release.`,
    timerCue_pt: `Aperte.
Segure 10.
Solte.`,
    feel: 'Strong sustained lift. A growing tiredness in the floor as the reps build.',
    feel_pt: 'Elevação sustentada forte. Cansaço crescente no assoalho conforme as repetições avançam.',
    avoid: 'Do not hold breath. Do not bear down.',
    avoid_pt: 'Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 8,
    hold: 10,
    relax: 10,
    rest: 0,
  },

  standing_squeeze: {
    id: 'standing_squeeze',
    name: 'Standing Squeeze',
    name_pt: 'Aperto em Pé',
    sub: 'Squeeze against gravity. Standing is harder.',
    sub_pt: 'Aperte contra a gravidade. Em pé é mais difícil.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. No wall support.

CLOSE and SQUEEZE at 60% for 5 seconds. Release for 5 seconds.

Standing squeezes are harder because gravity pulls on organs. If you cannot hold 5 seconds standing, reduce to 3.

Picture it: an invisible hand gently lifting your pelvic floor from below while you stand. The hand holds for 5 seconds, then lets go.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Sem apoio.

FECHE e APERTE em 60% por 5 segundos. Solte por 5 segundos.

Apertos em pé são mais difíceis porque gravidade puxa órgãos. Se não conseguir segurar 5 segundos, reduza para 3.

Visualize: uma mão invisível levantando suavemente seu assoalho de baixo enquanto está de pé. A mão segura 5 segundos, depois solta.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Hold.
Release.`,
    timerCue_pt: `Aperte.
Segure.
Solte.`,
    feel: 'Lift against gravity. The floor working with more effort to rise upward.',
    feel_pt: 'Elevação contra a gravidade. O assoalho trabalhando com mais esforço para subir.',
    avoid: 'Do not lock knees. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não trave joelhos. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  the_knack: {
    id: 'the_knack',
    name: 'The Knack',
    name_pt: 'O Knack',
    sub: 'Squeeze BEFORE the impact. Then release.',
    sub_pt: 'Aperte ANTES do impacto. Depois solte.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand upright.

Squeeze pelvic floor 1 second BEFORE each action. Hold through it. Release after.

Sequence 1: Squeeze, then cough. Release. 5 times.
Sequence 2: Squeeze, then bend to pick up object. Release. 5 times.
Sequence 3: Squeeze, then laugh out loud. Release. 5 times.
Sequence 4: Squeeze, then jump gently. Release. 5 times.

The squeeze ALWAYS comes before the impact.

Picture it: a goalkeeper bracing before a shot. They position BEFORE the ball arrives. Not during. Not after. Preparation before impact.`,
    inst_pt: `Fique de pé.

Aperte assoalho 1 segundo ANTES de cada ação. Mantenha durante. Solte depois.

Sequência 1: Aperte, depois tussa. Solte. 5 vezes.
Sequência 2: Aperte, depois abaixe para pegar objeto. Solte. 5 vezes.
Sequência 3: Aperte, depois ria alto. Solte. 5 vezes.
Sequência 4: Aperte, depois pule suavemente. Solte. 5 vezes.

O aperto SEMPRE vem antes do impacto.

Visualize: goleira se preparando antes do chute. Posiciona ANTES da bola chegar. Não durante. Não depois. Preparação antes do impacto.`,
    breathe: 'Squeeze before action. Release after.',
    breathe_pt: 'Aperte antes da ação. Solte depois.',
    timerCue: `Squeeze.
Action.
Release.`,
    timerCue_pt: `Aperte.
Ação.
Solte.`,
    feel: 'A small contraction landed before the impact, not after.',
    feel_pt: 'Uma pequena contração que chega antes do impacto, não depois.',
    avoid: 'Do not squeeze after the impact. The squeeze has to land first.',
    avoid_pt: 'Não aperte depois do impacto. O aperto tem que chegar antes.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },
};

export const days = [
  {
    day: 91, week: 13,
    title: 'Day 91', title_pt: 'Dia 91',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 92, week: 14,
    title: 'Day 92', title_pt: 'Dia 92',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'standing_squeeze', overrides: {"sets": 11} }, // 110s
    ], // Total: 302.0s = 5.0 min
  },
  {
    day: 93, week: 14,
    title: 'Day 93', title_pt: 'Dia 93',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 94, week: 14,
    title: 'Day 94', title_pt: 'Dia 94',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'standing_squeeze', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 95, week: 14,
    title: 'Day 95', title_pt: 'Dia 95',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 292.0s = 4.9 min
  },
  {
    day: 96, week: 14,
    title: 'Day 96', title_pt: 'Dia 96',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 97, week: 14,
    title: 'Day 97', title_pt: 'Dia 97',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'the_knack', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 98, week: 14,
    title: 'Day 98', title_pt: 'Dia 98',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'the_knack', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 99, week: 15,
    title: 'Day 99', title_pt: 'Dia 99',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'the_knack', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 100, week: 15,
    title: 'Day 100', title_pt: 'Dia 100',
    exercises: [
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
    ], // Total: 282s = 4.7 min
  },
  {
    day: 101, week: 15,
    title: 'Day 101', title_pt: 'Dia 101',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'the_knack', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 102, week: 15,
    title: 'Day 102', title_pt: 'Dia 102',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
    ], // Total: 320s = 5.3 min
  },
  {
    day: 103, week: 15,
    title: 'Day 103', title_pt: 'Dia 103',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 104, week: 15,
    title: 'Day 104', title_pt: 'Dia 104',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 105, week: 15,
    title: 'Day 105', title_pt: 'Dia 105',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 106, week: 16,
    title: 'Day 106', title_pt: 'Dia 106',
    exercises: [
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
    ], // Total: 282.0s = 4.7 min
  },
  {
    day: 107, week: 16,
    title: 'Day 107', title_pt: 'Dia 107',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 108, week: 16,
    title: 'Day 108', title_pt: 'Dia 108',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'standing_squeeze', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 109, week: 16,
    title: 'Day 109', title_pt: 'Dia 109',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 110, week: 16,
    title: 'Day 110', title_pt: 'Dia 110',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'belly_breath_drop', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 111, week: 16,
    title: 'Day 111', title_pt: 'Dia 111',
    exercises: [
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'bridge_activation', overrides: {"sets": 11} }, // 110s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 112, week: 16,
    title: 'Day 112', title_pt: 'Dia 112',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 113, week: 17,
    title: 'Day 113', title_pt: 'Dia 113',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'standing_squeeze', overrides: {"sets": 12} }, // 120s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 114, week: 17,
    title: 'Day 114', title_pt: 'Dia 114',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
      { ref: 'standing_squeeze', overrides: {"sets": 17} }, // 170s
    ], // Total: 298s = 5.0 min
  },
  {
    day: 115, week: 17,
    title: 'Day 115', title_pt: 'Dia 115',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_10s', overrides: {"sets": 6} }, // 120s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 116, week: 17,
    title: 'Day 116', title_pt: 'Dia 116',
    exercises: [
      { ref: 'the_knack', overrides: {} }, // 150s
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 117, week: 17,
    title: 'Day 117', title_pt: 'Dia 117',
    exercises: [
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 118, week: 17,
    title: 'Day 118', title_pt: 'Dia 118',
    exercises: [
      { ref: 'the_knack', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 119, week: 17,
    title: 'Day 119', title_pt: 'Dia 119',
    exercises: [
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 120, week: 18,
    title: 'Day 120', title_pt: 'Dia 120',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
];


export const monthMeta = {
  month: 4,
  program: 'weak_pf',
  phase: 'Transition',
  phase_pt: 'Transicao',
  days_range: [91, 120],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}